import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppResponse } from '../app/response';
import { map } from 'rxjs/operators';
import { ApiPaths } from 'src/app/core/constants/api-paths.enum';
import { environment } from 'src/environments/environment';
import { interplanReleaseDataServiceToUi } from '@data/interplanReleaseData/interplan-release-data';
import { AdminNotification, removeAdminNotification } from './admin-notification';
import { InterplanReleaseDataService } from '@data/interplanReleaseData/interplan-release-data.service';

@Injectable({
  providedIn: 'root'
})
export class AdminNotificationService {

  adminNotificationList:AdminNotification[]=[];

  isAdminNotificationUpdated = new BehaviorSubject<boolean>(false);

  constructor(private _inter: InterplanReleaseDataService) {
  }


  //for unviewed release date notification
  fetchInterplanData(){
    this._inter.getAllUnSynchedInterplanTitles().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this._inter.serviceResult = r.serviceResult??[];
          this._inter.interplanReleaseDateDataUi = interplanReleaseDataServiceToUi(r.serviceResult??[]);
          this._inter.isInterplanDataFetched.next(true);
          if(this._inter.interplanReleaseDateDataUi?.data?.length){
            let notify:AdminNotification={
              count:1,
              sec: "manageReleaseDate",
              tab: "manageReleaseDate",
              type: "unViewedDate"
            }
            this.adminNotificationList.push(notify);
            this.isAdminNotificationUpdated.next(true);
          }
        }
      }
    )

  }

  removeNotification(tab:string[]|null, sec:string[]|null){
    this.adminNotificationList = removeAdminNotification(this.adminNotificationList,tab,sec);
  }


}
